import React, {FC} from "react";
import {FormComponent} from '../components/form/FormComponent'

const Login: FC = () => {


    return (
            <FormComponent/>
    )
}

export default Login